import * as styles from "./Overlay.styles";

interface Props {
  isOpen: boolean;
  onClick: () => void;
}

const Overlay = ({ isOpen, onClick }: Props) => {
  const conditionalSidebarStyles = [styles.overlay.base, isOpen && styles.overlay.active];
  const closeSidebar = () => {
    if (isOpen) {
      onClick();
    }
  };

  return <div onClick={closeSidebar} css={conditionalSidebarStyles} data-testid="overlay" />;
};

export { Overlay };
